import { useEffect, useRef } from "react";

import { publicBaseUrl } from "../../common/envconst";
import { addJWTInConfig } from "../../components/apiHooks/helpers";
import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { usePaymentContext } from "../../contexts/PaymentContext/PaymentContext";
import { PATH } from "../../router/path";
import { ADYEN_RESULT_CODE } from "./types";

const HOST: string = process.env.CLOUD_RUN_GATEWAY_HOST ?? "";
const END_POINT: string = process.env.API_PAYMENT ?? "";

const url: string = `${HOST}${END_POINT}`;

export const getRedirectDomain = () => {
	const origin = globalThis.location?.origin ?? "";
	const base = publicBaseUrl === "/" ? "" : publicBaseUrl;
	const search = globalThis.location?.search ?? "";

	return `${origin}${base}${PATH.ORDER_CONFIRMATION}${search}`;
};

const useSubmitPayment = (onError?: (error: any) => void) => {
	const {
		state: { user },
	} = useConfigContext((state) => state);
	const { state: paymentReference } = usePaymentContext((state) => state.paymentReference);
	const payload = {
		url,
		triggerOnMount: false,
		axiosConfig: addJWTInConfig(undefined, user?.session_id?.toString() ?? ""),
		swrConfig: {
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			revalidateIfStale: false,
			shouldRetryOnError: false,
			errorRetryInterval: 0,
			errorRetryCount: 0,
		},
		onError: onError,
	};
	const actionRef = useRef<any>(null);
	const { data: response, postData } = useApiRequestPost(payload);
	const submitPayment = (paymentDataFromAdyen: any, actions: any) => {
		const payload = {
			paymentReference,
			...paymentDataFromAdyen,
			redirectDomain: getRedirectDomain(),
			returnUrl: `${globalThis.location.origin}${PATH.ORDER_CONFIRMATION}`,
			onError: (error: any) => {
				actions.reject();
				if (onError) {
					onError(error);
				}
			},
		};

		postData(payload);
		actionRef.current = actions;
	};

	useEffect(() => {
		if (!response || !actionRef?.current) return;
		const { resultCode, action, order, donationToken } = response;

		// Handle Refused payment status
		if (resultCode === ADYEN_RESULT_CODE.REFUSED) {
			actionRef.current.reject({
				resultCode,
				refusalReason: response.refusalReason || "Payment was refused",
			});

			// Call error handler with translated message for Refused payments
			if (onError) {
				onError({
					response: {
						data: {
							message: "paymentPage.error.cardRefused",
						},
					},
				});
			}

			return;
		}

		actionRef.current?.resolve({
			resultCode,
			action,
			order,
			donationToken,
		});
	}, [response, actionRef, onError]);

	return { submitPayment };
};

export default useSubmitPayment;
